import React, { useState, useEffect, useCallback } from "react";
import "./Weather.css";
import WeatherInfo from "./WeatherInfo";
import axios from "axios";
import WeatherDetails from "./WeatherDetails";
import searchButton from "./Images/search-button.png";
import locationButton from "./Images/current-location.png";
import Forecast from "./Forecast";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  const handleResponse = useCallback((response) => {
    setWeatherData({
      ready: true,
      temperature: response.data.main.temp,
      coordinates: response.data.coord,
      feelsLike: response.data.main.feels_like,
      windSpeed: response.data.wind.speed,
      city: response.data.name,
      precipitation: 15,
      description: response.data.weather[0].description,
      humidity: response.data.main.humidity,
      date: new Date(response.data.dt * 1000),
      icon: response.data.weather[0].icon,
    });
  }, []);

  useEffect(() => {
    const search = () => {
      const apiKey = "2bd326a60dc89a53287e446e819664df";
      const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
      axios.get(apiUrl).then(handleResponse);
    };

    search();
  }, [city, handleResponse]);

  function handleSubmit(event) {
    event.preventDefault();
    setCity(event.target.elements.city.value);
  }

const getCurrentLocationWeather = () => {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const apiKey = "2bd326a60dc89a53287e446e819664df";
      const { latitude, longitude } = position.coords;
      const apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;

      axios
        .get(apiUrl)
        .then(handleResponse)
        .catch((error) => {
          console.error("Error fetching weather data:", error);
          
        });
    },
    (error) => {
      console.error("Error getting geolocation:", error);
      
    }
  );
};
  if (weatherData.ready) {
    return (
      <div className="Weather">
        <WeatherInfo data={weatherData} unit={props.unit} changeUnit={props.changeUnit} />
        <div className="Form p-2">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-2">
                <button
                  type="submit"
                  className="w-100 rounded btn main-buttons"
                  onClick={getCurrentLocationWeather}
                >
                  <img src={locationButton} alt="current-location-button" />
                </button>
              </div>
              <div className="col-8">
                <p className="m-0">Enter Location </p>
                <input
                  type="search"
                  placeholder="ex. Paris"
                  className="form-control"
                  autoFocus
                  name="city"
                />
              </div>
              <div className="col-2">
                <button type="submit" className="w-100 rounded btn main-buttons">
                  <img src={searchButton} alt="Search" />
                </button>
              </div>
            </div>
          </form>
        </div>
        <WeatherDetails
          windSpeed={weatherData.windSpeed}
          humidity={weatherData.humidity}
          precipitation={weatherData.precipitation}
          unit={props.unit}
        />
        <Forecast coordinates={weatherData.coordinates} unit={props.unit} changeUnit={props.changeUnit} />
      </div>
    );
  } else {
    return null;
  }
}
